/* unplugin-vue-components disabled */import __unplugin_components_0 from '~icons/ep/arrow-left';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/svgs/fullScreen.svg';
import _imports_1 from '../../assets/svgs/closeFullScreen.svg';
const _withScopeId = n => (_pushScopeId("data-v-3847fe62"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "back flex items-center"
};
const _hoisted_2 = {
  class: "left-extra-back"
};
const _hoisted_3 = {
  class: "left-extra"
};
const _hoisted_4 = {
  class: "right-extra flex items-center"
};
const _hoisted_5 = ["id"];
const _hoisted_6 = {
  key: 0,
  style: {
    "width": "24px"
  },
  src: _imports_0,
  alt: ""
};
const _hoisted_7 = {
  key: 1,
  style: {
    "width": "24px"
  },
  src: _imports_1,
  alt: ""
};
const _hoisted_8 = {
  class: "content"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {
      type: String,
      default: '默认标题'
    },
    disabled: {
      type: Boolean,
      default: null
    },
    modelValue: {
      type: String,
      default: ''
    },
    panes: {
      type: Array,
      default: () => []
    },
    beforeBack: {
      type: Function,
      default: null
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    }
  },
  emits: ['back', 'update:modelValue', 'fullScreen'],
  setup(__props, {
    emit: __emit
  }) {
    const cardEl = ref(null);
    const {
      isFullscreen,
      toggle
    } = useFullscreen(cardEl);
    const props = __props;
    const _disabled = computed(() => {
      if (props.disabled !== null) {
        return props.disabled;
      } else {
        if (props.panes.length) {
          let firstKey = props.panes[0].key;
          return props.modelValue === firstKey;
        }
      }
    });
    const queueList = ref([]);
    watch(() => props.modelValue, val => {
      if (val) {
        if (queueList.value.indexOf(val) === -1) {
          queueList.value.push(val);
        }
      }
    }, {
      immediate: true
    });
    const paneTitle = computed(() => {
      if (props.panes.length) {
        let current = props.panes.find(item => item.key === props.modelValue);
        return current && current.title || '';
      } else {
        return '';
      }
    });
    const paneClass = computed(() => {
      if (props.panes.length) {
        let current = props.panes.find(item => item.key === props.modelValue);
        return current && current.class || '';
      } else {
        return '';
      }
    });
    const _active = computed(() => {
      return props.modelValue;
    });
    provide('active', _active);
    const emits = __emit;
    watch(() => isFullscreen, val => {
      emits('fullScreen', val.value);
    }, {
      immediate: true,
      deep: true
    });
    const handleClickBack = () => {
      if (!_disabled.value) {
        if (props.beforeBack) {
          let res = props.beforeBack();
          if (res) {
            goBack();
          }
        } else {
          goBack();
        }
      }
    };
    const goBack = () => {
      emits('back');
      queueList.value.pop();
      emits('update:modelValue', queueList.value[queueList.value.length - 1]);
      // if (props.panes.length) {
      // 	let index = props.panes.findIndex(item => item.key === props.modelValue);
      // 	const currentLevel = props.panes[index].level;
      // 	if (currentLevel !== undefined) {
      // 		index = currentLevel;
      // 	}
      // 	let prevKey = index - 1 > -1 ? props.panes[index-1].key : '';
      // 	if (prevKey) {
      // 		emits('update:modelValue', prevKey);
      // 	}
      // }
    };
    return (_ctx, _cache) => {
      const _component_i_ep_ArrowLeft = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['u-card', __props.shadow ? 'shadow' : '']),
        ref_key: "cardEl",
        ref: cardEl
      }, [_createElementVNode("div", {
        class: _normalizeClass(["top", _unref(paneClass)])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "left-extra-back")]), !_unref(_disabled) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['back-btn']),
        onClick: handleClickBack
      }, [_createVNode(_component_i_ep_ArrowLeft)])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass([_unref(_disabled) ? '' : 'title'])
      }, [_ctx.$slots.title ? _renderSlot(_ctx.$slots, "title", {
        key: 0
      }) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(_unref(paneTitle) || __props.title), 1)], 64))], 2), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "left-extra")])]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "extra"), _createElementVNode("div", {
        id: _unref(_active)
      }, null, 8, _hoisted_5), __props.fullScreen ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "full-screen flex-center",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(toggle) && _unref(toggle)(...args))
      }, [!_unref(isFullscreen) ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7))])) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_8, [_renderSlot(_ctx.$slots, "default")])], 2);
    };
  }
});